export default {
  state: {
    user: {
      currentUser: {},
    }
  },

  getters: {
    currentUser(state){
      return state.user.currentUser;
    }
  },

  mutations: {
    SET_CURRENT_USER(state,value){
      state.user.currentUser = value;
      console.log("current User: ", value);
    }
  },

  actions: {},
};
